import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import '../../App.css.js';
import { textColorText } from '../../theme/text-theme.js';
import '../media/Img.js';
import { Icon as Icon$1 } from '../media/Icon.js';
import Text from '../text/text.component.js';
var _excluded = ["style", "breadcrumb", "LinkComponent", "textStyle", "theme", "isMobile", "color"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var List = styled.ul.withConfig({
  displayName: "breadcrumbcomponent__List",
  componentId: "sc-2xxhmx-0"
})(["display:flex;flex-direction:row;align-items:center;box-sizing:border-box;margin:0;margin-block:0;margin-block-start:0;padding-inline-start:0;@media screen and (max-width:768px){}"]);
var Element = styled.li.withConfig({
  displayName: "breadcrumbcomponent__Element",
  componentId: "sc-2xxhmx-1"
})(["display:flex;flex-direction:row;align-items:center;@media screen and (max-width:768px){}"]);
var Icon = styled(Icon$1).withConfig({
  displayName: "breadcrumbcomponent__Icon",
  componentId: "sc-2xxhmx-2"
})(["", ""], textColorText);
var Breadcrumb = function Breadcrumb(_ref) {
  var style = _ref.style,
    breadcrumb = _ref.breadcrumb,
    LinkComponent = _ref.LinkComponent,
    textStyle = _ref.textStyle;
  _ref.theme;
  _ref.isMobile;
  var color = _ref.color;
  _objectWithoutProperties(_ref, _excluded);
  var list = [];
  breadcrumb.forEach(function (element, index) {
    list.push( /*#__PURE__*/React__default.createElement(Element, {
      key: "breadcrumb" + index
    }, index != 0 ? /*#__PURE__*/React__default.createElement(Icon, {
      key: "arrow-" + index,
      icon: "chevron_right",
      fontSize: "24px",
      color: color
    }) : "", index != breadcrumb.length - 1 ? /*#__PURE__*/React__default.createElement(LinkComponent, {
      key: "link-" + index,
      to: element.link,
      title: element.text,
      style: {
        textDecoration: "none"
      }
    }, /*#__PURE__*/React__default.createElement(Text, {
      fontFamily: "euclid",
      type: "paragraph",
      fontSize: "medium",
      color: color,
      hover: true,
      style: _objectSpread({}, textStyle)
    }, element.text)) : /*#__PURE__*/React__default.createElement(Text, {
      fontFamily: "euclid",
      type: "paragraph",
      fontSize: "medium",
      color: color,
      hover: true,
      style: _objectSpread({}, textStyle)
    }, element.text)));
  });
  return /*#__PURE__*/React__default.createElement(List, {
    style: style
  }, list);
};
Breadcrumb.defaultProps = {
  color: "grey-1",
  breadcrumb: []
};
var breadcrumb_component = withTheme(Breadcrumb);
export { breadcrumb_component as default };